import { Controller } from "@hotwired/stimulus"

// Copies profile-derived values into the wrapping form's fields. Source is a
// JSON object keyed by the underlying model attribute name (e.g.
// agent_first_name). modelName parameterizes the form field selector so the
// controller is reusable across forms (agent_website_setting,
// agent_business_card_setting, etc.). Empty/nil values are skipped so the
// button never wipes a field the agent has already typed; only blanks get
// replaced.
export default class extends Controller {
  static values = {
    source: Object,
    modelName: String
  }

  copy() {
    Object.entries(this.sourceValue).forEach(([fieldName, value]) => {
      if (value === null || value === "") return
      // CSS.escape both interpolations defensively. Today both values are
      // server-controlled (fixed Rails symbol names / model strings) so
      // no live injection risk exists, but escaping here keeps the
      // controller safe for future reuse on user-controlled input.
      const input = this.element.querySelector(
        `[name="${CSS.escape(this.modelNameValue)}[${CSS.escape(fieldName)}]"]`
      )
      if (!input) return
      input.value = value
      input.dispatchEvent(new Event("input", { bubbles: true }))
      input.dispatchEvent(new Event("change", { bubbles: true }))
    })
  }
}
